import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=9405cbfa"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=9405cbfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports